<div class="flex items-center gap-1">
  <span class="box-border h-2 w-2 rounded-sm" [ngClass]="stylesAndClasses.classes" [ngStyle]="stylesAndClasses.styles">
  </span>
  {{ item.label }}
</div>
